/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { sendTestEmail } from '../fn/test-email/send-test-email';
import { SendTestEmail$Params } from '../fn/test-email/send-test-email';

@Injectable({ providedIn: 'root' })
export class TestEmailService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sendTestEmail()` */
  static readonly SendTestEmailPath = '/api/v1/email/send-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendTestEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendTestEmail$Response(params?: SendTestEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendTestEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendTestEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  sendTestEmail(params?: SendTestEmail$Params, context?: HttpContext): Observable<void> {
    return this.sendTestEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
